import { useContext, useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { ManagedAccountContext } from "../../context/ManagedAccountContext";

export const useManagedAccountInfo = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(null);

    const { authState } = useOktaAuth();
    const { managedAccountModule, setManagedAccountModule } = useContext(ManagedAccountContext);

    useEffect(() => {
        const fetchAccountInfo = async () => {
            try {
                const res = await fetch(
                    `${process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT}/managed-accounts/read`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: authState.accessToken.accessToken,
                            "Content-Type": "application/json",
                            Accept: "application/json",
                        },
                        body: JSON.stringify({
                            userPrincipalName: managedAccountModule.upn,
                            dn: managedAccountModule.dn,
                        }),
                    }
                );

                if (!res.ok) {
                    let errorMsg = "Unknown error occurred";
                    try {
                        const errorBody = await res.json();
                        errorMsg = errorBody?.error?.message || errorMsg;
                    } catch {
                        // Ignore JSON parsing error
                    }
                    throw new Error(errorMsg);
                }

                const result = await res.json();
                setManagedAccountModule((prev) => ({ ...prev, data: result, isLoaded: true }));
                setIsLoaded(true);
                setError(null);
            } catch (err) {
                setError(err);
                setIsLoaded(true);
            }
        };

        fetchAccountInfo();
    }, [authState.accessToken.accessToken, managedAccountModule.upn, managedAccountModule.dn, setManagedAccountModule]);

    return { isLoaded, error };
};
